/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import template from './workspace-edit-workspace.component.html';

import type {WorkspaceGridsterResource} from './workspace-gridster-item.component';
import {APP_SHARED} from '../common/app-shared';
import {GridsterWorkspaceComponent} from '../common/directives/gridster-workspace.component';
import {WorkspaceGridsterItemEditComponent} from './workspace-gridster-item.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, GridsterWorkspaceComponent, WorkspaceGridsterItemEditComponent],
  selector: 'adn-workspace-edit-workspace',
  template
})
export class WorkspaceEditWorkspaceComponent {
  @Input() widgets: any[] = [];
  @Input() pending = false;
  @Input() gridsterOpts: any;
  @Input() gridsterResource: WorkspaceGridsterResource;

  readonly layoutChangeHandler = () => this.layoutChange.emit();

  @Output() addWidgets = new EventEmitter<void>();
  @Output() layoutChange = new EventEmitter<void>();
}
